module.exports = __webpack_public_path__ + "img/HT.e64ed9e3.svg";